<template>
  <el-container>
    <div class="headerCom"> 
      <publicBreadCrumb :breadList="breadList"/>
      <publicFoldSearch :searchList='searchList' v-on:getSearchObj='getSearchObj' />
    </div>
    <el-main class="bottom-tabel">
      <el-table :data="tableData" :header-cell-style="{
			  background:'#FAFAFA',
			  fontWeight: 'bold',
			  color: '#333333',
			  fontSize:'14px', 
        textAlign: 'center',
			}">
        <el-table-column prop="no" label="意见ID">
        </el-table-column>
        <el-table-column prop="doctorName" label="姓名">
        </el-table-column>
        <el-table-column v-if="$store.state.userPlatForm === 'platForm'" prop="belongTo" label="来源机构">
        </el-table-column>
        <el-table-column prop="createTime" label="反馈时间">
          <template slot-scope="scope">
            {{ scope.row.createTime|filterValgang }}
          </template>
        </el-table-column>
        <el-table-column prop="replyTime" label="回复时间">
          <template slot-scope="scope">
            {{ scope.row.replyTime|filterValgang }}
          </template>
        </el-table-column>
        <el-table-column prop="opinionContent" label="反馈内容">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.opinionContent">
              <span class="fieldWidth">{{scope.row.opinionContent|filterValgang }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">未查看</span>
            <span v-if="scope.row.status==1">已查看</span>
            <span v-if="scope.row.status==2">已回复</span>
          </template>
        </el-table-column>
        <el-table-column align="center" fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            <el-button @click="checkDetail(scope.row)" type="text" size="small">
              查看
            </el-button>
            <el-button :disabled="scope.row.status==2" @click="checkDetail(scope.row,true)" type="text" size="small">
              回复
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchParams.current" :page-size="searchParams.size"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </el-main>
    <el-dialog class="feed-back-dialog" :close-on-click-modal="false" @close="resetForm" title="反馈详情" center width="880px"
      :visible.sync="dialogFormVisible">
      <el-form :model="form" ref="ruleForm" :rules="formRule" label-position='left' label-width="100px"
        label-suffix="：">
        <div class="sub-title"> <span></span>反馈内容</div>
        <el-form-item label="姓名">{{form.doctorName}}</el-form-item>
        <el-form-item label="反馈内容">
          <div style="max-height:150px;overflow:auto">{{form.opinionContent}}</div>
        </el-form-item>
        <el-form-item label="反馈图片" class="feed-img">
          <img v-for='(item,index) in  form.opinionFiles' @click="handleImg(item)" :key="index"
            :src="item|assembleImgSrc" alt="">
        </el-form-item>
        <div class="sub-title" v-if="replyStatus"> <span></span>回复内容</div>
        <el-form-item label="回复反馈" v-if="curRow.status == 2">{{form.replyContent}}</el-form-item>
        <el-form-item label="回复反馈" v-if="replyStatus" key='1000' prop="replyContent">
          <el-input style="min-height: 120px;" type="textarea" placeholder="请输入回复内容" v-model="form.replyContent"
            maxlength="500" show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item v-if="!replyStatus" class="feed-img">
          <img :src="item|assembleImgSrc" @click="handleImg(item)" v-for='(item,index) in form.replyFiles' :key="index"
            alt="">
        </el-form-item>
        <el-form-item v-if="replyStatus" class="upload-box">
          <div v-for='(item,index) in srcList' class="feed-img" :key="index">
            <img :src="item|assembleImgSrc" @click="handleImg(item)" alt="">
            <i class="el-icon-error" @click="delFeedImg(index)"></i>
          </div>
          <div class="self-upload" v-if="hideUp">
            <el-upload :action="$defaultData.upImgSrc" list-type="picture-card" :before-upload="beforeAvatarUpload"
              :data="{ path: 'dsicm-doctor' }" :headers="headers" :show-file-list="false" :on-success="handleChange">
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <span class="upload-tips" v-if="hideUp">*非必填，最多上传9张</span>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button type="primary" size="small" v-if="!replyStatus && curRow.status != 2" @click="updateFeedBack('0')">
          回复
        </el-button>
        <el-button type="primary" size="small" v-if="!replyStatus && curRow.status == 2" @click="updateFeedBack('1')">
          确定
        </el-button>
        <el-button type="primary" size="small" v-if="replyStatus" @click="updateFeedBack('2')">确定回复</el-button>
      </div>
    </el-dialog>
    <el-dialog width="60%" class="large-img" center :visible.sync="dialogFormImg">
      <img :src="largeImg|assembleImgSrc" alt="">
    </el-dialog>
  </el-container>
</template> 
<script>
import { feedbackList, replyFeedbacK, getFeedbacKDetails } from "./api";
import { plateFormAll } from "@/api/acc.js";
import { jsonp } from "vue-jsonp";
export default {
  data() {
    return {
      breadList:[{name:'机构组织'},{name:'意见反馈'}],
      headers: {
        Authorization: localStorage.getItem("Authorization")
      },
      searchList: [
         {
          label: "ID",
          value: 1,
          paramName: "no",
          inputType: "input"
        },
        {
          label: "姓名",
          value: 2,
          paramName: "doctorName",
          inputType: "input"
        },
        {
          label: "反馈内容",
          value: 3,
          paramName: "opinionContent",
          inputType: "input"
        },
        {
          label: "反馈时间",
          value: 4,
          paramName: "timeRange",
          inputType: "datetimerange",
          isTime:true,
          paramstartTime: "createStartTime",
          paramEndTime: "createEndTime"
        },
        {
          label: "回复时间",
          value: 5,
          paramName: "timeRange",
          inputType: "datetimerange",
          isTime:true,
          paramstartTime: "replyStartTime",
          paramEndTime: "replyEndTime"
        }, 
        {
          label: "状态",
          value: 6,
          paramName: "status",
          inputType: "select", 
          optionData: [
            { value: 0, label: "未查看" },
            { value: 1, label: "已查看" },
            { value:2, label: "已回复" }
          ]
        }, 
         {
          label: "来源机构",
          value: 7,
          paramName: "hospitalId",
          inputType: "hospital",
          optionData: [] 
        }, 
      ],
      searchParams: { 
        current: 1,
        size: 10
      },
      // searchType: "",
      // searchOldList: [
      //   {
      //     label: "ID",
      //     value: 1
      //   },
      //   {
      //     label: "姓名",
      //     value: 2
      //   },
      //   {
      //     label: "反馈内容",
      //     value: 3
      //   },
      //   {
      //     label: "反馈时间",
      //     value: 4
      //   },
      //   {
      //     label: "回复时间",
      //     value: 5
      //   },
      //   {
      //     label: "状态",
      //     value: 6
      //   },
      //   {
      //     label: "来源机构",
      //     value: 7
      //   }
      // ],
      // hospitalList: [],
      dialogFormImg: false,
      replyStatus: false,
      curRow: {},
      srcList: [],
      largeImg: null,
      hideUp: true,
      // listQuery1: {
      //   no: "",
      //   doctorName: "",
      //   opinionContent: "",
      //   hospitalObj: "",
      //   createTime: [],
      //   updateTime: [],
      //   status: ""
      // },
      // listQuery: {
      //   no: "",
      //   doctorName: "",
      //   opinionContent: "",
      //   hospitalObj: "",
      //   createStartTime: "",
      //   createTime: "",
      //   replyStartTime: "",
      //   replyEndTime: "",
      //   status: "",
      //   current: 1,
      //   size: 10
      // },
      userid: "",
      form: {
        id: "",
        doctorName: "",
        replyContent: null,
        opinionContent: "",
        opinionFiles: [],
        replyFiles: ""
      },
      dialogFormVisible: false,
      total: 0,
      tableData: [],
      decisionType: [],
      diseaseListData: [],
      formRule: {
        replyContent: [
          {
            required: true,
            message: "请输入回复内容",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    var ary = [0, 1, 2]
    ary[10] = 10
    ary = ary.filter(function(x) {
      return x === undefined
    })
    console.log('ary', ary)
    this.getList();
    // this.getHospitalData();
  },
  mounted() {
    if (this.$store.state.userPlatForm != "platForm") {
      this.searchList.splice(-1, 1);
    }
  },
  methods: {
    getSearchObj(obj) {
      //清空之前合并过的条件
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.getList();
    },
    getList() {
      if(this.searchParams.hospitalName){
        delete this.searchParams.hospitalName
      }
      feedbackList(this.searchParams).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    },
    checkDetail(row, replay) {
      this.dialogFormVisible = true;
      this.curRow = row;
      if (replay) {
        this.replyStatus = true;
      } else {
        this.replyStatus = false;
      }
      getFeedbacKDetails(row.id).then(res => {
        this.form = res.data;
        if (res.data.opinionFiles) {
          this.form.opinionFiles = res.data.opinionFiles.split(",");
        }
        if (res.data.replyFiles) {
          this.form.replyFiles = res.data.replyFiles.split(",");
        }
      });
    },
    updateFeedBack(val) {
      if (val == "0") {
        this.replyStatus = true;
      }
      if (val == "1") {
        this.dialogFormVisible = false;
      }
      if (val == "2") {
        this.$refs["ruleForm"].validate(valid => {
          if (valid) {
            let imgList = JSON.parse(JSON.stringify(this.srcList));
            let obj = {
              id: this.form.id,
              replyContent: this.form.replyContent,
              replyFiles: imgList.join()
            };
            replyFeedbacK(obj).then(res => {
              this.$message.success("操作成功");
              this.dialogFormVisible = false;
              this.resetForm();
              this.getList();
            });
          } else {
            return false;
          }
        });
      }
    },
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpg" ||
        file.type === "image/png" ||
        file.type === "image/jpeg";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传头像图片大小不能超过 5MB!");
      }
      return isJPG && isLt5M;
    },
    handleChange(file) {
      this.srcList.push(file.data);
      this.$message.success("上传成功");
      if (this.srcList.length >= 9) {
        this.hideUp = false;
      }
    },
    handleImg(src) {
      this.dialogFormImg = true;
      this.largeImg = src;
    },
    delFeedImg(index) {
      this.srcList.splice(index, 1);
      if (this.srcList.length < 9) {
        this.hideUp = true;
      }
    },
    resetForm() {
      this.form.id = "";
      this.srcList = [];
      this.$refs["ruleForm"].resetFields();
      this.getList();
    },
    handleSizeChange(val) {
      this.searchParams.size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.getList();
    }
  }
};
</script>

<style scoped lang="less">
.el-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.feed-back-dialog {
  /deep/.el-dialog__body {
    padding-top: 0;
    height: 75vh;
  }

  /deep/.el-dialog__footer {
    padding-top: 0;
    padding-bottom: 10px;
  }
}
.large-img {
  img {
    max-width: 80%;
    max-height: 700px;
    display: inline-block;
  }
  /deep/.el-dialog__body {
    text-align: center;
  }
}
/deep/.bottom-tabel .el-table .cell {
  text-align: center;
}
.feed-img img {
  width: 60px;
  height: 60px;
  border-radius: 2px;
  margin-right: 15px;
  display: inline-block;
  cursor: pointer;
}
.upload-box {
  .feed-img {
    width: 60px;
    height: 60px;
    float: left;
    border-radius: 2px;
    position: relative;
    margin-right: 10px;
    i {
      font-size: 18px;
      position: absolute;
      right: 5px;
      top: 5px;
      color: #fff;
    }
  }
  .self-upload {
    width: 60px;
    height: 60px;
    display: inline-block;
    border-radius: 2px;
    margin-right: 10px;
  }
  /deep/.el-upload {
    width: 60px;
    height: 60px;
    line-height: 60px;
  }
  .upload-tips {
    vertical-align: bottom;
  }
}
.sub-title {
  font-size: 14px;
  font-weight: bold;
  line-height: 22px;
  margin-bottom: 25px;
  span {
    display: inline-block;
    background: #1a7bfc;
    width: 4px;
    height: 14px;
    margin-right: 8px;
    vertical-align: middle;
  }
}

.a-tag {
  border-radius: 11px;
  margin-right: 15px;
}
.fieldWidth {
  display: inline-block;
  max-width: 100px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
/deep/.el-textarea textarea {
  min-height: 120px !important;
}


.bottom-tabel {
  background-color: #fff;
  padding: 16px 17px 0;
  margin: 0 15px;
}

/deep/.el-pagination {
  text-align: right;
  margin-top: 30px;
  margin-right: 30px;
  padding-bottom: 20px;
}

/deep/.el-select {
  width: 100%;
}
.dialog-footer {
  text-align: center;
  margin-top: 40px;
}
/deep/.el-textarea__inner {
  padding-bottom: 20px;
}
/deep/.el-textarea .el-input__count {
  height: 0;
  color: #909399;
  background: #fff;
  position: absolute;
  font-size: 12px;
  bottom: 34px;
  right: 24px;
}
/deep/.el-textarea__inner {
  resize: none;
}
/deep/.el-upload {
  width: 60px;
  height: 60px;
  line-height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
